<template>
  <!-- 用户管理-赠送月卡 -->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="添加月卡"
      width="350px"
      @close="closeDialog"
    >
      <el-form
        ref="dataForm"
        label-width="80px"
        size="small"
        :rules="replyRules"
      >
        <el-form-item prop="receive_amount" label="月卡种类">
          <el-select v-model="card_id" placeholder="请选择月卡">
            <el-option
              v-for="item in dataForm"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="submit" :loading="buttonLoading"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  props: {
    visible: {//展示标志
      type: Boolean,
      default: false
    },
    value: {//数据
      type: Object,
      default: undefined
    },
    type: {//类型
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      lock: false,//加锁
      dataForm: undefined,
      card_id: undefined,//月卡的id
      replyRules: {//回复弹窗规则验证
      }
    }
  },
  computed: {
    ...mapState({
    }),
    dialogVisible: {
      get() {
        return this.visible
      },
      set() {
      }
    },
    fromInfo: {
      get() {
        return this.value
      },
      set() {
      }
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.getData()
      }
    },
  },
  created() {
  },
  methods: {
    getData() {
      //拿取所有的月卡信息
      getApiData('all_member_card').then(res => {
        this.dataForm = res
      }).finally(() => {
      })
    },
    submit() {
      //保存任务
      //表单验证后发起请求
      if (!this.card_id) {
        this.$message.success("请先选择月卡")
        return
      }
      this.buttonLoading = true
      let params = {
        user_id: this.fromInfo.id,
        member_card_id: this.card_id
      }
      postApiData('member_card_user', params).then(res => {
        if (res.code) {
          this.$message.success(res.message)
          this.$emit('refresh')
          this.closeDialog()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    closeDialog() {
      //关闭弹窗
      this.$emit("close")
    }
  }

}
</script>
<style lang="less" scoped>
</style>